/* Mendly — comportements de la marque (sans dépendance). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Compte à rebours ---------- */
  // data-end="2026-10-31T23:59" : fin réelle de l'offre. Sans date : minuit (heure de Madrid).
  function madridMidnight() {
    const now = new Date();
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(now);
    const get = (t) => Number(parts.find((p) => p.type === t).value);
    const elapsed = (get('hour') % 24) * 3600 + get('minute') * 60 + get('second');
    return now.getTime() + (86400 - elapsed) * 1000;
  }
  // data-evergreen="877" : compteur par visiteur (minutes), mémorisé dans le navigateur, relancé à zéro.
  function evergreenEnd(minutes) {
    const key = 'gg_cd_end';
    let e = 0;
    try { e = Number(localStorage.getItem(key)) || 0; } catch (_) {}
    if (!e || e <= Date.now() || e - Date.now() > minutes * 60000) {
      e = Date.now() + minutes * 60000;
      try { localStorage.setItem(key, String(e)); } catch (_) {}
    }
    return e;
  }
  function initCountdowns() {
    $$('[data-gg-countdown]').forEach((el) => {
      const ever = Number(el.dataset.evergreen || 0);
      const endAttr = ever > 0 ? '' : el.dataset.end;
      let end = ever > 0 ? evergreenEnd(ever) : (endAttr ? new Date(endAttr).getTime() : madridMidnight());
      const d = $('[data-d]', el), dws = $$('[data-dwrap]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let left = Math.max(0, end - Date.now());
        if (left === 0 && ever > 0) { end = evergreenEnd(ever); left = end - Date.now(); }
        else if (left === 0 && !endAttr) { end = madridMidnight(); left = end - Date.now(); }
        if (left === 0 && endAttr) { const wrap = el.closest('[data-gg-promo-timer]'); if (wrap) wrap.hidden = true; }
        let t = Math.floor(left / 1000);
        const days = Math.floor(t / 86400);
        if (d) { d.textContent = days; dws.forEach((x) => { x.hidden = days === 0; }); t -= days * 86400; }
        h.textContent = pad(Math.floor(t / 3600));
        m.textContent = pad(Math.floor((t % 3600) / 60));
        s.textContent = pad(t % 60);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- En-tête : ombre au défilement + tiroir ---------- */
  function initHeader() {
    const wrap = $('[data-gg-header]');
    if (wrap) {
      const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    const drawer = $('[data-gg-drawer]');
    if (!drawer) return;
    const open = () => { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; $('[data-gg-drawer-close]', drawer)?.focus(); };
    const close = () => { drawer.removeAttribute('open'); document.body.style.overflow = ''; };
    $$('[data-gg-drawer-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-gg-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.hasAttribute('open')) close(); });
  }

  /* ---------- Offres : tous les sélecteurs de la page restent synchronisés ---------- */
  function applyVariant(input) {
    const id = input.value;
    const d = input.dataset;
    // Les offres se reconnaissent à leur n° (en mode quantité, elles partagent la même variante)
    $$('[data-gg-offers] input[data-gg-variant]').forEach((r) => { r.checked = r.dataset.index === d.index; });
    $$('[data-gg-id]').forEach((i) => { i.value = id; });
    $$('[data-gg-qty]').forEach((q) => { q.value = d.qty || '1'; });
    $$('[data-gg-gift]').forEach((g) => { g.value = d.gift || ''; });
    $$('[data-gg-gift2]').forEach((g) => { g.value = d.gift2 || ''; });
    $$('[data-gg-price]').forEach((p) => { p.textContent = d.price; });
    $$('[data-gg-compare]').forEach((c) => { c.textContent = d.compare || ''; c.hidden = !d.compare; });
    $$('[data-gg-save]').forEach((s) => { s.textContent = d.save || ''; });
    $$('[data-gg-save-wrap]').forEach((w) => { w.hidden = !d.save; });
    const available = d.available === 'true';
    $$('[data-gg-atc]').forEach((b) => {
      b.disabled = !available;
      const label = $('[data-gg-atc-label]', b);
      if (label) {
        if (!label.dataset.addText && available) label.dataset.addText = label.textContent.trim();
        label.textContent = available ? (label.dataset.addText || label.textContent) : (window.variantStrings?.soldOut || 'Épuisé');
      }
    });
    const idx = Number(d.index || 1);
    $$('[data-gg-tiers] .gg-tier').forEach((t) => t.classList.toggle('is-locked', idx < Number(t.dataset.unlock || 1)));
    if (Number(d.qty || 1) > 1) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    window.history.replaceState({}, '', url.toString());
  }
  function initOffers() {
    $$('[data-gg-atc-label]').forEach((l) => { if (!l.closest('[data-gg-atc]').disabled) l.dataset.addText = l.textContent.trim(); });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-gg-offers] input[data-gg-variant]');
      if (input) applyVariant(input);
    });
  }

  /* ---------- Date de livraison estimée (jours ouvrés) ---------- */
  function addBusinessDays(date, n) {
    const d = new Date(date);
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }
  function initDelivery() {
    $$('[data-gg-delivery]').forEach((el) => {
      const it = (el.dataset.lang || document.documentElement.lang || '').startsWith('it');
      const fmt = new Intl.DateTimeFormat(it ? 'it-IT' : 'fr-FR', { day: 'numeric', month: 'long' });
      const min = Number(el.dataset.min || 6), max = Number(el.dataset.max || 8);
      // jours calendaires (le marchand livre en 6 à 8 jours, week-ends compris)
      const addDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
      const a = fmt.format(addDays(min)), b = fmt.format(addDays(max));
      const t = $('[data-gg-delivery-text]', el);
      if (t) t.innerHTML = it ? `Ordina oggi, ricevilo entro il <strong>${b}</strong>` : `Commandez aujourd'hui, recevez-le avant le <strong>${b}</strong>`;
    });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery() {
    $$('[data-gg-gallery]').forEach((g) => {
      const track = $('[data-gg-track]', g);
      const slides = $$('.gg-gallery__slide', track);
      const dots = $$('[data-gg-dot]', g), thumbs = $$('[data-gg-thumb]', g);
      const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      const sync = () => {
        const i = current();
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
      dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
      thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
      $('[data-gg-prev]', g)?.addEventListener('click', () => go(Math.max(0, current() - 1)));
      $('[data-gg-next]', g)?.addEventListener('click', () => go(current() + 1 >= slides.length ? 0 : current() + 1));
      sync();
    });
  }

  /* ---------- Carrousels (rails) avec points ---------- */
  function initRails() {
    $$('[data-gg-rail]').forEach((rail) => {
      const dotsWrap = rail.parentElement.querySelector('[data-gg-rail-dots]');
      if (!dotsWrap) return;
      const items = Array.from(rail.children);
      const build = () => {
        const perView = Math.max(1, Math.round(rail.clientWidth / (items[0]?.getBoundingClientRect().width || rail.clientWidth)));
        const pages = Math.max(1, items.length - perView + 1);
        dotsWrap.innerHTML = '';
        dotsWrap.hidden = pages <= 1;
        for (let i = 0; i < pages; i++) {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'gg-slider__dot'; b.setAttribute('aria-label', `Ir a ${i + 1}`);
          b.addEventListener('click', () => rail.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' }));
          dotsWrap.appendChild(b);
        }
        sync();
      };
      const sync = () => {
        const step = (items[1]?.offsetLeft || 0) - (items[0]?.offsetLeft || 0) || rail.clientWidth;
        const i = Math.round(rail.scrollLeft / step);
        Array.from(dotsWrap.children).forEach((d, k) => d.classList.toggle('is-active', k === Math.min(i, dotsWrap.children.length - 1)));
      };
      // data-gg-autoheight : sur mobile, la hauteur du carrousel suit la carte affichée (une carte à la fois)
      const auto = rail.hasAttribute('data-gg-autoheight');
      const fit = () => {
        if (!auto) return;
        if (window.matchMedia('(min-width: 990px)').matches) { rail.style.height = ''; return; }
        const step = (items[1]?.offsetLeft || 0) - (items[0]?.offsetLeft || 0) || rail.clientWidth;
        const it = items[Math.min(items.length - 1, Math.max(0, Math.round(rail.scrollLeft / step)))];
        if (!it) return;
        const cs = getComputedStyle(rail);
        rail.style.height = `${it.offsetHeight + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)}px`;
      };
      // La hauteur ne change qu'une fois le glissement terminé : la modifier pendant le geste fait sauter la page
      let settle;
      rail.addEventListener('scroll', () => {
        window.requestAnimationFrame(sync);
        if (!auto) return;
        clearTimeout(settle);
        settle = setTimeout(fit, 140);
      }, { passive: true });
      if (auto && 'onscrollend' in window) rail.addEventListener('scrollend', () => { clearTimeout(settle); fit(); });
      window.addEventListener('resize', () => { build(); fit(); });
      if (auto) $$('img', rail).forEach((im) => { if (!im.complete) im.addEventListener('load', fit); });
      build();
      fit();
    });
  }

  /* ---------- Apparition au défilement ---------- */
  function initReveal() {
    const els = $$('.gg-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Barre d'achat collante (mobile) ---------- */
  function initSticky() {
    const bar = $('[data-gg-sticky]');
    const mainAtc = $('[data-gg-main-buy] [data-gg-atc]');
    if (!bar || !mainAtc) return;
    let pastMain = false, offerVisible = false;
    const update = () => bar.classList.toggle('is-visible', pastMain && !offerVisible);
    new IntersectionObserver(([en]) => { pastMain = !en.isIntersecting && en.boundingClientRect.top < 0; update(); }).observe(mainAtc);
    const offerSec = $('[data-gg-offer-section]');
    if (offerSec) new IntersectionObserver(([en]) => { offerVisible = en.isIntersecting; update(); }).observe(offerSec);
    $('[data-gg-sticky-btn]', bar)?.addEventListener('click', () => mainAtc.click());
  }

  /* ---------- Timeline : progression au défilement ---------- */
  function initTimeline() {
    $$('[data-gg-timeline]').forEach((tl) => {
      const steps = $$('.gg-step', tl);
      const update = () => {
        const r = tl.getBoundingClientRect();
        const mid = window.innerHeight * 0.6;
        const p = Math.min(1, Math.max(0, (mid - r.top) / r.height));
        tl.style.setProperty('--gg-progress', `${(p * 100).toFixed(1)}%`);
        steps.forEach((s) => s.classList.toggle('is-active', s.getBoundingClientRect().top < mid));
      };
      update();
      window.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    });
  }

  /* ---------- Ancres internes (en tenant compte de l'en-tête collant) ---------- */
  function initAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      const target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      const offset = ($('[data-gg-header]')?.offsetHeight || 0) + 12;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    });
  }


  /* ---------- Bouton d'achat → paiement direct (comme Resilia) ---------- */
  function initDirectCheckout() {
    /* Retour arrière depuis le paiement : la page revient du cache avec le bouton encore « en chargement ».
       On le débloque à chaque affichage pour pouvoir racheter. */
    const resetAtc = () => {
      document.querySelectorAll('[data-gg-atc]').forEach((b) => { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); });
      document.querySelectorAll('form[data-gg-direct="true"] .loading__spinner').forEach((s) => s.classList.add('hidden'));
    };
    window.addEventListener('pageshow', resetAtc);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') setTimeout(() => { if (!document.hidden && Date.now() - (window.__ggAtcAt || 0) > 4000) resetAtc(); }, 300); });
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.ggDirect !== 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const btn = form.querySelector('[data-gg-atc]');
      const spin = form.querySelector('.loading__spinner');
      if (btn) { if (btn.getAttribute('aria-disabled') === 'true') return; btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); window.__ggAtcAt = Date.now(); }
      if (spin) spin.classList.remove('hidden');
      try {
        // Pots de l'offre + cadeau mystère éventuel (une seule fois par panier)
        const fd = new FormData(form);
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
        // Cadeaux : guide (toutes offres cadeau) + kit nuit (offre 150 jours), une seule fois chacun par panier
        const gifts = ['[data-gg-gift]', '[data-gg-gift2]'].map((sel) => form.querySelector(sel)?.value).filter(Boolean);
        if (gifts.length) {
          let inCart = [];
          try { inCart = (await fetch(`${root}cart.js`).then((r) => r.json())).items.map((i) => String(i.variant_id)); } catch (err) { inCart = []; }
          gifts.forEach((g) => { if (!inCart.includes(String(g))) items.push({ id: Number(g), quantity: 1 }); });
        }
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('add');
        window.location.href = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}checkout`;
      } catch (err) {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        if (spin) spin.classList.add('hidden');
        const wrap = form.querySelector('.product-form__error-message-wrapper');
        if (wrap) { wrap.hidden = false; const m = wrap.querySelector('.product-form__error-message'); if (m) m.textContent = (document.documentElement.lang || '').startsWith('it') ? "Impossibile aggiungere al carrello. Riprova." : "Impossible d'ajouter au panier. Réessayez."; }
      }
    }, true);
  }

  const init = () => {
    initCountdowns(); initHeader(); initOffers(); initDelivery(); initGallery();
    initRails(); initReveal(); initSticky(); initTimeline(); initAnchors(); initDirectCheckout();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { initGallery(); initRails(); initReveal(); initDelivery(); initCountdowns(); });
})();
